
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import sw from './locales/sw.json';
import ha from './locales/ha.json';
import yo from './locales/yo.json';
import am from './locales/am.json';
import zu from './locales/zu.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import tw from './locales/tw.json';
import kpe from './locales/kpe.json';

const resources = {
  en: { translation: en },
  sw: { translation: sw },
  ha: { translation: ha },
  yo: { translation: yo },
  am: { translation: am },
  zu: { translation: zu },
  es: { translation: es },
  fr: { translation: fr },
  pt: { translation: pt },
  tw: { translation: tw },
  kpe: { translation: kpe },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
